import React, { useState } from "react";
import { YuJaTextBox } from "../../components/standardization/YuJaTextBox";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {
    END_DATE,
    POLL_TYPE_HEADER, ROLES,
    SEARCH_EVENT_BANNER,
    START_DATE, USER_ROLE_TEXT,
} from '../../utils/constants';
import classes from "./EventBannerPage.module.css";
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import {Button} from "@base-ui/react/button";
import EventBannerFilter from "./EventBannerFilter";

export default function EventBannerSearchForm({handleSubmit, filter={},}) {
    const [keyword, setKeyword] = useState(!!filter.keyword ? filter.keyword : "");
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [startDate, setStartDate] = useState(!!filter.startDate ? filter.startDate : "");
    const [endDate, setEndDate] = useState(!!filter.endDate ? filter.endDate : "");
    const [roleFilter, setRoleFilter] = useState(!!filter.role ? filter.role : ([]));



    const clickSearch = ({key=keyword, start=startDate, end=endDate, role=roleFilter}) => {
        let formattedStartDate = start ? start.split("-").join("-") : "";
        let formattedEndDate = end ? end.split("-").join("-") : "";
        handleSubmit({
            keyword: key,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            role: role
        });
    };



    const onApply = (filterOptions) => {

        setRoleFilter(filterOptions.optionFilter1);
        setStartDate(filterOptions.dateFilter1);
        setEndDate(filterOptions.dateFilter2);
        clickSearch({
            start: filterOptions.dateFilter1,
            end: filterOptions.dateFilter2,
            role: filterOptions.optionFilter1,
        });


    };

    return (
        <div className={classes.row} style={{width: "100%", gap: 10}}>
            <div style={{flex: 1, minWidth: 0,}}/>
            <EventBannerFilter
                show={showFilterMenu}
                setShow={setShowFilterMenu}
                onApply={onApply}
                style={{width: "min(80vw, 300px)", maxHeight: "min(80vh, 650px)"}}
                filterOptions={
                    {
                        optionFilter1Name: USER_ROLE_TEXT,
                        optionFilter1: roleFilter,
                        // optionsFilter1: [ALL_ROLES, ROLES.IT_MANAGER.display, ROLES.CREATOR.display, ROLES.VIEWER.display],
                        optionsFilter1: [ROLES.IT_MANAGER.display, ROLES.CREATOR.display, ROLES.VIEWER.display],
                        dateFilter1Name: START_DATE,
                        dateFilter1: startDate,
                        dateFilter2Name: END_DATE,
                        dateFilter2: endDate
                    }
                }
            />

            <YuJaTextBox
                containerStyle={{fontSize: 14, lineHeight: 1.6, flexShrink: 1, height: 35, maxWidth: 450, minWidth: 200}}
                placeholder={SEARCH_EVENT_BANNER}
                onChange={e => {
                    let key = e.target.value;
                    setKeyword(key);
                    clickSearch({key});
                }}
                value={keyword}
                before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                after={
                    !!keyword
                        ? (
                            <Button
                                aria-label={"Clear search keyword"}
                                className={classes.closeIcon}
                                onClick={() => {
                                    setKeyword("");
                                    clickSearch({key: ""});
                                }}
                            >
                                <CLOSE style={{width: 16, height: 16}}/>
                            </Button>
                        )
                        : (<></>)
                }
            />
            <div style={{flex: 1, minWidth: 0}}/>
        </div>
    );
}